import { render, staticRenderFns } from "./a11.vue?vue&type=template&id=cd96e47e&scoped=true&"
import script from "./a11.vue?vue&type=script&lang=js&"
export * from "./a11.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd96e47e",
  null
  
)

export default component.exports